($ => {
  function headerSizeTrack() {
    const stickyEl = document.querySelector('.cpb-preview-sticky');
    const stickyHeader = document.querySelector('.pageheader--sticky');

    if (!stickyEl || !stickyHeader) return;

    function setHeaderHeight() {
      stickyEl.style.setProperty('--header-height', stickyHeader.clientHeight + 'px');
    }

    new ResizeObserver(setHeaderHeight).observe(stickyHeader);

    setHeaderHeight();
  }

  function priceNoVAT() {
    // Added Newbuild.Studio
    // Only show message for foreign currencies
    const cartCurrency = window?.ShopifyAnalytics?.meta?.currency || window.Shopify.currency.active;
    if (cartCurrency === 'GBP') return
    // End

    const priceWrappers = $('.cpb-product-full-price')
    const prices = priceWrappers.find('.cpb-product-price')
    const customPrices = []
    const priceTemplate = (() => {
      const price = prices.eq(0).text()
      return price.split(price.match(/[0-9,\.]+/)[0])
    })()

    priceWrappers.each(function () {
      const priceWrapper = $(this)
      const customPriceWrapper = $('<div class="cpb-custom-no-vat-price-wrapper">')
      const customPrice = $('<div class="cpb-custom-no-vat-price">')
      customPriceWrapper.append(customPrice, '<span>exc. VAT</span>')
      customPrices.push(customPrice)
      priceWrapper.after(customPriceWrapper)
    })

    updatePrices()
    new MutationObserver(updatePrices).observe(prices[0], { subtree: true, characterData: true })

    $('#product-builder').attr('data-custom-price-no-vat', true)

    function getPriceWithPointCentsSeparator(priceWithSeparators) {
      if (priceWithSeparators.includes(',')) {
        if (priceWithSeparators.includes('.')) {
          const firstSeparator = priceWithSeparators.match(/[,\.]/)
          priceWithSeparators = priceWithSeparators.replace(firstSeparator, '')
        }
        return priceWithSeparators.replace(',', '.')
      }
      return priceWithSeparators
    }
    function getPriceNumber() {
      const price = prices.eq(0).text()
      let priceNumber = +getPriceWithPointCentsSeparator(price.match(/[0-9,\.]+/)[0])
      return priceNumber
    }

    function updatePrices() {
      const priceNumber = getPriceNumber()
      let noVatPriceString = (priceNumber / 1.2).toFixed(2)
      if (noVatPriceString.length > 6) noVatPriceString = noVatPriceString.substring(0, noVatPriceString.length - 6) + ',' + noVatPriceString.substring(noVatPriceString.length - 6)
      const showPrice = priceTemplate[0] + noVatPriceString + priceTemplate[1]
      customPrices.forEach(customPrice => {
        customPrice.text(showPrice)
      })
    }
  }

  function showWeight() {
    const weightElements = []

    $('.cpb-product-actions-first').append((() => {
      return createWeightElement()
    })())

    let alohaMobilePrice = $('.cpb-preview-aside .cpb-custom-no-vat-price-wrapper')
    if (alohaMobilePrice.length === 0) alohaMobilePrice = $('.cpb-preview-aside .cpb-product-full-price')

    alohaMobilePrice.after((() => {
      return createWeightElement()
    })())

    updateWeights()

    document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', updateWeights)

    function createWeightElement() {
      const weightContainer = $('<div class="cpb-custom-product-weight">').append('<span>Weight: </span>')
      const weight = $('<span>')
      weightContainer.append(weight)
      weightElements.push(weight)
      return weightContainer
    }

    // Added Newbuild.Studio
    // Include unit and conversion to imperial
    function weightWithUnits(kg) {
      const kg_to_oz = 35.273968
      const g = kg * 1000
      const ozs = Math.round((kg * kg_to_oz) * 1000) / 1000
      const oz = Math.round((ozs % 16) * 10) / 10
      const lb = Math.floor(ozs / 16)
      return `${g} g / ${lb} lb ${oz} oz`
    }

    function updateWeights() {
      weightElements.forEach(weightEl => {
        weightEl.text(weightWithUnits(getWeight()))
      })
    }

    function getWeight() {
      const product = CPB.getStore().getState().Product
      let weight = 0
      product.layers.forEach(layer => {
        const panel = product.panels.find(panel => panel.id === layer.panel)
        if (!panel) return
        const category = panel.categories.find(category => category.id === layer.category)
        const option = category.options.find(option => option.id === layer.option)
        weight += +option.weight
      })
      return Math.round(weight * 1000) / 1000
    }
  }

  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', () => {
    headerSizeTrack()
    priceNoVAT()
    showWeight()
  })
})(jQuery)
